import {
  FabAdditionalImagesQueryStateType,
  GetFabAdditionalImagesQueryParamsType,
} from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabAdditionalImages/getFabAdditionalImagesQuery.type';
import { getFabAdditionalImagesFunction } from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabAdditionalImages/getFabAdditionalImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getFabAdditionalImagesQueryOptions = (
  params: GetFabAdditionalImagesQueryParamsType,
) => {
  const generateUrl = (state: FabAdditionalImagesQueryStateType) => {
    switch (state) {
      case 'bodyAdjusterAdditional':
        return `body/reports/${params.id}/fab/adjuster/additional/`;
      case 'bodyCustomerAdditional':
        return `body/reports/${params.id}/fab/customer/additional/`;
      case 'initialAdjusterAdditional':
        return `initial/reports/${params.id}/fab/adjuster/additional/`;
      case 'initialCustomerAdditional':
        return `initial/reports/${params.id}/fab/customer/additional/`;
      case 'propertyCulpritAdjusterAdditional':
        return `property/reports/${params.id}/accident_users/culprit/fab/adjuster/additional/`;
      case 'propertyCulpritCustomerAdditional':
        return `property/reports/${params.id}/accident_users/culprit/fab/customer/additional/`;
      case 'propertyDamagedAdjusterAdditional':
        return `property/reports/${params.id}/accident_users/damaged/fab/adjuster/additional/`;

      case 'propertyDamagedCustomerAdditional':
        return `property/reports/${params.id}/accident_users/damaged/fab/customer/additional/`;
    }
  };
  return queryOptions({
    queryKey: ['FabAdditionalImages', params],
    queryFn: () =>
      getFabAdditionalImagesFunction({
        url: generateUrl(params.state),
        damagedId: params.damagedId,
      }),
    enabled: true,
  });
};
